export default __webpack_public_path__ + "right-bar-empty-plus.03097324.png";